import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import { errorText } from '../pages/SoftwarePolicy/policyEdit';

const KEY = 'v2Account';
const stored = () => { try { return sessionStorage.getItem(KEY); } catch (ex) { return null; } };
const remember = (code) => { try { sessionStorage.setItem(KEY, code); } catch (ex) { /* not remembered */ } };

// The accounts the person may see and the one chosen, shared by the V2 pages: from ?account= in the address, else the last one chosen,
// else the first.
export function useV2Account() {
  const jApi = useApi();
  const apiRef = useRef(jApi);
  apiRef.current = jApi;
  const [params, setParams] = useSearchParams();
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    apiRef.current.request('GET', 'cma/account')
      .then((response) => {
        if (cancelled) return;
        const sorted = (response.data || []).slice().sort((a, b) => a.code.localeCompare(b.code));
        setAccounts(sorted);
        const wanted = params.get('account') || stored();
        setAccount(sorted.find((a) => a.code === wanted) || sorted[0] || null);
      })
      .catch((ex) => { if (!cancelled) setError(errorText(ex)); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const choose = (code) => {
    const found = accounts.find((a) => a.code === code);
    if (!found) return;
    setAccount(found);
    remember(found.code);
    const next = new URLSearchParams(params);
    next.delete('account');
    setParams(next, { replace: true });
  };

  return { accounts, account, choose, error };
}
